import Vue from 'vue';
import Vuex from 'vuex';
import { putData } from './api/putData.js';

Vue.use(Vuex);

const DEFAULT = `
  <div>广州医行健康是一家专注于“互联网+大健康”的创新型企业，为目标客户提供“医疗+养老”全业务场景的信息化解决方案，覆盖慢病管理、社区养老、居家养老、机构养老、医养结合等多个实际业务场景。请问您需要咨询哪方面的内容呢？</div>
  <div style="color: #5DC2D0; cursor: pointer;" id="healthKY" key="1">医行智慧康养平台</div>
  <div style="color: #5DC2D0; cursor: pointer;" id="chronic" key="2">慢病管理</div>
  <div style="color: #5DC2D0; cursor: pointer;" id="rare" key="4">罕见病及短缺药品管理</div>
  <div style="color: #5DC2D0; cursor: pointer;" id="clinical" key="3">临床用药信息管理</div>
`
const TIP = '好的，请留下您的联系方式，我们会安排专业的业务人员与您详谈。'
const END = '非常感谢您的支持，我们会尽快安排专业的业务人员联系您，请您留意接听。祝您生活愉快，再见！'

const phoneReg = /^[1][2,3,4,5,6,7,8,9][0-9]{9}$/

const store = new Vuex.Store({
  state: {
    hasPhone: false,
    // 客服会话
    messages: [{
      content: DEFAULT,
    }]
  },
  mutations: {
    SEND (state, payload) {
      state.messages.push(...payload)
    },
    SETPHONE (state, flag) {
      state.hasPhone = flag
    }
  },
  actions: {
    async send ({ state, commit }, payload) {
      let newMsg = []
      const consult = state.messages.find(item => item.isConsult)  // 判断是否已咨询项目
      
      if (!consult) {
        newMsg = [{
          ...payload,
          self: true
        }, {
          content: payload.isConsult ? TIP : DEFAULT
        }]
        commit('SEND', newMsg)
        return
      }

      if (consult && state.hasPhone) {
        newMsg = [{
          ...payload,
          self: true
        }, {
          content: END
        }]
        commit('SEND', newMsg)
        return
      }

      if (phoneReg.test(payload.content.replace(/[^0-9]/ig, ''))) {
        try {
          await putData(payload.content, consult.content)
        } catch (e) {
          console.error(e)
        } finally {
          newMsg = [{
            ...payload,
            self: true
          }, {
            content: END
          }]
          commit('SETPHONE', true)
        }
      } else {
        newMsg = [{
          ...payload,
          self: true
        }, {
          content: TIP
        }]
      }
      commit('SEND', newMsg)
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store.js